/**
 *  Возвращает переданный элемент если массив, иначе приводит к массиву
 *  @param value элемент или массив элементов
 */
export const arrify = <T>(value: T | T[]): T[] => (Array.isArray(value) ? value : [value]);
